import React from 'react';
import styled from 'styled-components';

import { VerticalConfig } from 'utils/vertical';

type LayoutProps = {
  theme: VerticalConfig['theme'];
};

const Container = styled.div`
  /* Base scaffolding for the application */
  color: var(--text-base);
  background-color: var(--background-base);
  /* Needed to style the root div for sticky footer setup */
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* Fix background stacking to prevent gradient behind the main background */
  position: relative;
  z-index: 0;
`;

export const Layout: React.FunctionComponent<LayoutProps> = ({ theme, children }) => (
  <Container className={theme}>{children}</Container>
);
